import { render, staticRenderFns } from "./si_arrowsRight.vue?vue&type=template&id=856c71f4&scoped=true&"
import script from "./si_arrowsRight.vue?vue&type=script&lang=js&"
export * from "./si_arrowsRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856c71f4",
  null
  
)

export default component.exports